import { render } from "./Casting.vue?vue&type=template&id=2199c540&scoped=true"
import script from "./Casting.vue?vue&type=script&lang=js"
export * from "./Casting.vue?vue&type=script&lang=js"

import "./Casting.vue?vue&type=style&index=0&id=2199c540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2199c540"]])

export default __exports__